// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"388":"route-public","609":"route-start"}[chunkId] || chunkId) + "." + {"366":"bd1d29a5","388":"b4e029d5","607":"034ce562","609":"b4e029d5","968":"caac23c5"}[chunkId] + ".chunk.css";
};